module.exports = __webpack_public_path__ + "img/52_44.538dbc3f.png";